/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemSettingResponseDtoValue } from './SystemSettingResponseDtoValue';
import {
    SystemSettingResponseDtoValueFromJSON,
    SystemSettingResponseDtoValueFromJSONTyped,
    SystemSettingResponseDtoValueToJSON,
    SystemSettingResponseDtoValueToJSONTyped,
} from './SystemSettingResponseDtoValue';

/**
 * 
 * @export
 * @interface SystemSettingHistoryItemResponseDto
 */
export interface SystemSettingHistoryItemResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    settingId?: string;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    settingKey: string;
    /**
     * 
     * @type {SystemSettingResponseDtoValue}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    previousValue?: SystemSettingResponseDtoValue;
    /**
     * 
     * @type {SystemSettingResponseDtoValue}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    newValue: SystemSettingResponseDtoValue;
    /**
     * 
     * @type {number}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    fromVersion: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    toVersion: number;
    /**
     * 
     * @type {string}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof SystemSettingHistoryItemResponseDto
     */
    changedAt: Date;
}

/**
 * Check if a given object implements the SystemSettingHistoryItemResponseDto interface.
 */
export function instanceOfSystemSettingHistoryItemResponseDto(value: object): value is SystemSettingHistoryItemResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('settingKey' in value) || value['settingKey'] === undefined) return false;
    if (!('newValue' in value) || value['newValue'] === undefined) return false;
    if (!('fromVersion' in value) || value['fromVersion'] === undefined) return false;
    if (!('toVersion' in value) || value['toVersion'] === undefined) return false;
    if (!('changedAt' in value) || value['changedAt'] === undefined) return false;
    return true;
}

export function SystemSettingHistoryItemResponseDtoFromJSON(json: any): SystemSettingHistoryItemResponseDto {
    return SystemSettingHistoryItemResponseDtoFromJSONTyped(json, false);
}

export function SystemSettingHistoryItemResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemSettingHistoryItemResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'settingId': json['settingId'] == null ? undefined : json['settingId'],
        'settingKey': json['settingKey'],
        'previousValue': json['previousValue'] == null ? undefined : SystemSettingResponseDtoValueFromJSON(json['previousValue']),
        'newValue': SystemSettingResponseDtoValueFromJSON(json['newValue']),
        'fromVersion': json['fromVersion'],
        'toVersion': json['toVersion'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'changedAt': (new Date(json['changedAt'])),
    };
}

export function SystemSettingHistoryItemResponseDtoToJSON(json: any): SystemSettingHistoryItemResponseDto {
    return SystemSettingHistoryItemResponseDtoToJSONTyped(json, false);
}

export function SystemSettingHistoryItemResponseDtoToJSONTyped(value?: SystemSettingHistoryItemResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'settingId': value['settingId'],
        'settingKey': value['settingKey'],
        'previousValue': SystemSettingResponseDtoValueToJSON(value['previousValue']),
        'newValue': SystemSettingResponseDtoValueToJSON(value['newValue']),
        'fromVersion': value['fromVersion'],
        'toVersion': value['toVersion'],
        'reason': value['reason'],
        'changedAt': value['changedAt'].toISOString(),
    };
}

